module.exports = __webpack_public_path__ + "static/media/evenbreeze-2.a8375728.jpg";